<template>
  <div class="row text-center">
    <div class="col-12">
      <section class="login">
        <div class="container">
          <div class="login__group">
            <h1 class="login__title">Entrar</h1>

            <form class="login__form">
              <div v-show="alertError" class="alert alert-danger" role="alert">
                Email e/ou senha estão incorretos
              </div>

              <div class="form-group">
                <input
                  id="exampleInputEmail1"
                  v-model="$v.operator.email.$model"
                  type="email"
                  class="form-control"
                  aria-describedby="emailHelp"
                  placeholder="E-mail"
                />

                <div v-if="$v.operator.email.$error" class="error">
                  <div v-if="!$v.operator.email.required" class="error">
                    Campo obrigatório
                  </div>
                  <div v-if="!$v.operator.email" class="error">
                    Email inválido
                  </div>
                </div>
              </div>

              <div class="form-group">
                <input
                  id="exampleInputPassword1"
                  v-model="$v.operator.password.$model"
                  type="password"
                  class="form-control"
                  placeholder="Senha"
                />
                <div v-if="$v.operator.password.$error" class="error">
                  <div v-if="!$v.operator.password.required" class="error">
                    Campo obrigatório
                  </div>
                </div>
              </div>

              <button
                type="submit"
                class="button3"
                @click.prevent="sendLogin()"
              >
                Entrar
              </button>
            </form>

            <!-- <div class="login__forgot">
              <a href="/recuperarSenha" class="login__forgot-item">
                Esqueci a senha
              </a>
            </div> -->
          </div>
        </div>
      </section>

      <section class="option-account">
        <div class="container option-account__wrapper">
          <p class="create-account__item">
            Primeira vez aqui?
            <a href="/cadastrar">Crie uma conta</a>
          </p>
        </div>
      </section>
    </div>
  </div>
</template>

<script>
import { operatorMethods, userComputed } from "./../state/helpers";
import { required, email } from "vuelidate/lib/validators";

export default {
  name: "OperatorLogin",
  data() {
    return {
      operator: {
        email: "",
        password: ""
      },
      redirectFrom: ""
    };
  },

  validations: {
    operator: {
      email: { required, email },
      password: { required }
    }
  },

  mounted() {
    this.redirectFrom = this.$route.query.redirectFrom;
  },

  methods: {
    ...operatorMethods,
    sendLogin() {
      this.$v.operator.$touch();
      if (!this.$v.operator.$invalid)
        this.login({ ...this.operator, redirectFrom: this.redirectFrom });
    }
  },

  computed: {
    ...userComputed
  }
};
</script>
